import React, {useState} from "react";
import axios from "axios";
import {getPostHeader} from "../../../Constants/requestHeaders";
import CloseTaskWithImage from "../../../Components/Modals/CloseTaskWithImage";
import {CLOSE_INSTALLATION_WITH_IMAGE} from "../../../Constants/strings/installation";

/**
 * @param open boolean
 * @param close: function that will close the modal
 * @param installationId: the id of the installation
 * @param refetch: function that reloads the installation data; use after the execute function
 * @param userId: the id of the current user
 *
 * @returns {JSX.Element}
 * @constructor
 */
const CloseWithImage = (props) => {
    const [loading, setLoading] = useState(false);

    const closeInstallation = async ({ image, observation}) => {
        try {
            setLoading(true);
            await axios.post('/api/close_installation_with_image', {
                image,
                installationId: props.installationId,
                observation,
                userId: props.userId,
            }, getPostHeader());
            await props.refetch();
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
            props.close();
        }
    }

    return (
        <CloseTaskWithImage
            open={props.open}
            close={() => props.close()}
            title={CLOSE_INSTALLATION_WITH_IMAGE[props.language] + " #" + props.installationId}
            language={props.language}
            loading={loading}
            execute={closeInstallation}
        />
    )
}

export default CloseWithImage;